import script from "./SnackbarNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./SnackbarNotification.vue?vue&type=script&setup=true&lang=js"

import "./SnackbarNotification.vue?vue&type=style&index=0&id=d4742ee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4742ee0"]])

export default __exports__